/* eslint-disable react/prop-types */
import GlobalTitle from "../shared/GlobalTitle";
import RoundedButton from "../ui/RoundedButton";

const NewsEvents = ({ data }) => {
  return (
    <div className="lg:border-r-2 lg:border-dashed lg:border-primary lg:pr-8">
      <GlobalTitle title={data.title} />
      <p className="pb-5 lg:pb-10">{data.description}</p>
      <RoundedButton href="/news-and-events">Go to the Newsroom</RoundedButton>
    </div>
  );
};

export default NewsEvents;
